var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * A deep-mode table artifact: the stored table's first rows as the server compiled them
 * (deep/tableformat.py). Sorts and filters the rows it has; identifier cells link to their
 * Easytrack page when the server sent a link for them.
 */
var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterText = '';
        _this.sortIndex = null;
        _this.sortDescending = false;
        return _this;
    }
    Object.defineProperty(DataTable.prototype, "config", {
        get: function () {
            return this.payload.config || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataTable.prototype, "rows", {
        get: function () {
            return this.payload.rows.map(function (cells, position) { return ({ position: position, cells: cells }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataTable.prototype, "visibleRows", {
        get: function () {
            var _this = this;
            var rows = this.rows;
            var needle = this.filterText.trim().toLowerCase();
            if (needle) {
                rows = rows.filter(function (row) { return row.cells.some(function (cell) { return _this.display(cell).toLowerCase().indexOf(needle) !== -1; }); });
            }
            if (this.sortIndex !== null) {
                var index_1 = this.sortIndex;
                var column = this.payload.columns[index_1];
                var sortValues_1 = (this.config.sortValues || {})[column];
                var direction_1 = this.sortDescending ? -1 : 1;
                rows = rows.slice().sort(function (a, b) {
                    var left = sortValues_1 ? sortValues_1[a.position] : a.cells[index_1];
                    var right = sortValues_1 ? sortValues_1[b.position] : b.cells[index_1];
                    return direction_1 * _this.compare(left, right);
                });
            }
            return rows;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataTable.prototype, "footer", {
        get: function () {
            var total = this.config.totalRows;
            if (!total || !this.showingRowsText)
                return '';
            return this.showingRowsText
                .replace('%(shown)s', String(this.payload.rows.length))
                .replace('%(total)s', String(total));
        },
        enumerable: false,
        configurable: true
    });
    DataTable.prototype.headingFor = function (column) {
        return (this.config.columnLabels || {})[column] || column;
    };
    DataTable.prototype.linkFor = function (column, position) {
        var links = (this.config.links || {})[column];
        return links ? links[position] || null : null;
    };
    DataTable.prototype.sortBy = function (index) {
        if (this.sortIndex === index) {
            this.sortDescending = !this.sortDescending;
        }
        else {
            this.sortIndex = index;
            this.sortDescending = false;
        }
    };
    DataTable.prototype.isNumber = function (value) {
        return typeof value === 'number';
    };
    DataTable.prototype.display = function (value) {
        if (value === null || value === undefined)
            return '';
        if (typeof value === 'boolean')
            return value ? '✓' : '–';
        if (typeof value === 'number') {
            return Number.isInteger(value) ? String(value) : String(Math.round(value * 1000) / 1000);
        }
        if (Array.isArray(value))
            return value.join(', ');
        return String(value);
    };
    DataTable.prototype.compare = function (left, right) {
        var leftEmpty = left === null || left === undefined || left === '';
        var rightEmpty = right === null || right === undefined || right === '';
        if (leftEmpty || rightEmpty)
            return leftEmpty === rightEmpty ? 0 : leftEmpty ? 1 : -1;
        if (typeof left === 'number' && typeof right === 'number')
            return left - right;
        return String(left).localeCompare(String(right), undefined, { numeric: true });
    };
    __decorate([
        Prop({ type: Object, required: true })
    ], DataTable.prototype, "payload", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], DataTable.prototype, "filterPlaceholder", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], DataTable.prototype, "showingRowsText", void 0);
    DataTable = __decorate([
        Component
    ], DataTable);
    return DataTable;
}(Vue));
export default DataTable;
